import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LibItem, UserShortInfo } from "../../types";
import { backend } from "../../services";
import { RootState } from "../../state/reducer";
import { toast } from "sonner";
import { CheckboxInput, GroupSelect, ManSelector, TextInput } from "../components";

interface ModalLoaderProps {
  onSave: () => void;
  closeModal: () => void;
}

const CreateSourceModal: React.FC<ModalLoaderProps> = ({
  onSave,
  closeModal,
}) => {
  const State = useSelector((state: RootState) => state);
  const rights = State.rights;
  const session = State.session;
  if (!session?.id) {
    return null;
  }
  const defaultResponsibleId = session.id;
  const [selectedUserId, setSelectedUser] =
    useState<number>(defaultResponsibleId);
  const [free, setFree] = useState<boolean>(true);
  const [linkName, setLinkName] = useState<string>();
  const [responceUsersToSelect, setUsersToSelect] = useState<UserShortInfo[]>(
    []
  );
  const groupList = State.groupsToSelect;
  const [selectedGroup, setSelectedGroup] = useState<number>(
    rights.group_ids[0]
  );

  const closeWithSave = async () => {
    console.log("Close with save called");
    await saveAction();
    onSave(); // Передаем новое фото в callback
    closeModal(); // Закрываем модальное окно
  };

  useEffect(() => {
    backend.getAllUsersShorts({ group_id: selectedGroup }).then((res) => {
      setUsersToSelect(res.users);
    });
  }, [groupList, selectedGroup]);

  const saveAction = async () => {
    console.log("Save action called");
    if (!linkName || !selectedUserId) {
      toast("Укажите название");
      return;
    }
    return new Promise((resolve) => {
      backend
        .addCustomerSource({
          name: linkName,
          userid: selectedUserId,
          free
        })
        .then(() => {
          onSave();
          toast("Источник добавлен");
          resolve(1);
        })
        .catch(() => {
          toast("Ошибка создания роли");
          resolve(0);
        });
    });
  };

  return (
    <div className="creationForm">
      <div className="modalHeading">
        <h3>Создание роли</h3>
      </div>
      <form className="columnCenter">
        <TextInput
          label="Название"
          value={linkName}
          onChange={(e) => setLinkName(e.target.value)}
          required
        />

        {rights.rang < 3 && (
          <GroupSelect
            label="Группа"
            groups={[{ id: 0, name: "Любая" }, ...groupList]}
            value={selectedGroup}
            onChange={setSelectedGroup}
          />
        )}

        <ManSelector
          label="Пользователь"
          users={responceUsersToSelect}
          selectedUserId={selectedUserId}
          onChange={setSelectedUser}
        />
        <CheckboxInput
          label="Добавлять клиентов как свободных"
          checked={free}
          onChange={(e) => setFree(e.target.checked)}
        />
        {/* Кнопки действий */}
        <div className="flex between btnRow">
          <button
            className="filterButton"
            type="button"
            onClick={closeWithSave}
          >
            Сохранить
          </button>
          <button className="cancelButton" type="button" onClick={closeModal}>
            Отменить
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateSourceModal;
